(function (api) {
    api.getPOsobaFields = getPOsobaFields;
    api.getPredmetFields = getPredmetFields;
    api.getBlStavFields = getBlStavFields;
    api.vBlaById = vBlaById;
    api.getBlTrosFields = getBlTrosFields; 
    api.getNoviRedniBroj = getNoviRedniBroj;
    api.blagObrisiSaStavkama = blagObrisiSaStavkama;
    api.izracunajIznosKn = izracunajIznosKn;
    api.izracunajBlTrosZaRasporediti = izracunajBlTrosZaRasporediti;
    api.osobaJeIzPOsoba = osobaJeIzPOsoba;
    api.blStavDefault = blStavDefault;
    api.getVBlaLista = getVBlaLista;
    api.GetOpcijeUnosaBlIzvj = GetOpcijeUnosaBlIzvj;
    api.GetOpcijeUnosa = GetOpcijeUnosa;
    api.SetObjectAfterVbla = SetObjectAfterVbla;
	api.OsobaPostoji = OsobaPostoji;	
	api.MozeJop = MozeJop;
	api.KreirajJop = KreirajJop;
	api.blStavObrisi = blStavObrisi;
	api.blStavMozeIzmijeni = blStavMozeIzmijeni;
	api.GetDatumByGodinaVblaRedni = GetDatumByGodinaVblaRedni;
	api.SpPutniKnjizPrijedlogOpaska = SpPutniKnjizPrijedlogOpaska;
	api.ProvjeriIznoseSP = ProvjeriIznoseSP;
	api.DajNalovGridaAk = DajNalovGridaAk;
	api.SetSpStatusIsplaceno = SetSpStatusIsplaceno;
	api.ProvjeriDaLiPostojiZbrojni = ProvjeriDaLiPostojiZbrojni;
	api.PripremaDisketeZaZN = PripremaDisketeZaZN;
	api.DajBlDokum = DajBlDokum;
	api.DajBlBrojDokum = DajBlBrojDokum;
	api.ProvjeriDokPostojiUGk = ProvjeriDokPostojiUGk;
	api.ArhivaGodinaValidate = ArhivaGodinaValidate;
	api.DajOtvoreneStavke = DajOtvoreneStavke;
	api.DajOsobaBlByZOsoba = DajOsobaBlByZOsoba;
	api.DajOsobaBlBySpDJelatnik = DajOsobaBlBySpDJelatnik;	
	api.SetObjectAfterOsoba = SetObjectAfterOsoba;
	api.SetObjectAfterSvrha = SetObjectAfterSvrha;
	api.ProvjeriDaliRnPostojiUSKPoDatumu = ProvjeriDaliRnPostojiUSKPoDatumu;
	api.ProvjeriDaliRnPostojiUSKPoPartneru = ProvjeriDaliRnPostojiUSKPoPartneru;	
	api.KojaUI = KojaUI;
	api.GetZadnjiBlIzvj = GetZadnjiBlIzvj;
	api.GetTecajNaDan = GetTecajNaDan;
	api.SpPutniPregDajFormaCaption = SpPutniPregDajFormaCaption;
	api.GetBankaByRacun = GetBankaByRacun;
	
    function getPredmetFields() {
        return $.dsDirectCall({
            method: "GetPredmetFields"
        });
    } 

    function getBlStavFields(vbla) {
        return $.dsDirectCall({
            method: "GetBlStavFields",
            params: [vbla]
        });
    } 

    function getBlTrosFields(blag) {
        return $.dsDirectCall({
            method: "GetBlTrosFields",
            params: [blag]
        });
    }     
    
    function getPOsobaFields() {
        return $.dsDirectCall({ 
            method: "GetPOsobaFields"
        });
    } 

    function vBlaById(godina, vbla) {
        return $.dsDirectCall({ 
            method: "VBlaById",
            params:[godina, vbla] 
        });
    }  
    
    function getNoviRedniBroj(uplatnica, pocetnoStanje, isplataNaRacun, imaObracunTroskova, imaIzvodBanke, godina, vbla) {
        return $.dsDirectCall({ 
            method: "GetNoviRedniBroj",
            params:[uplatnica, pocetnoStanje, isplataNaRacun, imaObracunTroskova, imaIzvodBanke, godina, vbla] 
        });
    }   
    
    function blagObrisiSaStavkama(blag) {
        return $.dsDirectCall({ 
            method: "BlagObrisiSaStavkama",
            params:[blag] 
        });
    }      

    function izracunajIznosKn(godina, iznos, tecaj, paritet) {
        return $.dsDirectCall({ 
            method: "IzracunajIznosKn",
            params:[godina, iznos, tecaj, paritet] 
        });
    } 

    function izracunajBlTrosZaRasporediti(blag) {
        return $.dsDirectCall({ 
            method: "IzracunajBlTrosZaRasporediti",
            params:[blag] 
        });
    }  
    
    function osobaJeIzPOsoba(predmet) {
        return $.dsDirectCall({ 
            method: "OsobaJeIzPOsoba",
            params:[predmet] 
        });
    }    
    
    function blStavDefault(blag) {
        return $.dsDirectCall({ 
            method: "BlStavDefault",
            params:[blag] 
        });
    }  
    
    function getVBlaLista() {
        return $.dsDirectCall({ 
            method: "GetVBlaLista"
        });
    }      

	function GetOpcijeUnosaBlIzvj(blizvj){
		 return $.dsDirectCall({ 
            method: "GetOpcijeUnosaBlIzvj",
            params: [ blizvj ]
        });
    }    
	
	function GetOpcijeUnosa(vbla, novi){
		 return $.dsDirectCall({ 
            method: "GetOpcijeUnosa",
            params: [ vbla, novi ]
        });
    }   
    
    function SetObjectAfterVbla(vbla, godina){
		 return $.dsDirectCall({ 
            method: "SetObjectAfterVbla",
            params: [ vbla, godina ]
        });
    }  
    
    function OsobaPostoji(id){
		 return $.dsDirectCall({ 
            method: "OsobaPostoji",
            params: [ id ]
        });
    }  
	
	function MozeJop(obj){
		 return $.dsDirectCall({ 
            method: "MozeJop",
            params: [ obj ]
        });
    }  
	
	function KreirajJop(obj){
		 return $.dsDirectCall({ 
            method: "KreirajJop",
            params: [ obj ]
        });
    } 
    
    function blStavObrisi(blStav) {
        return $.dsDirectCall({ 
            method: "BlStavObrisi",
            params:[blStav] 
        });
    }
	
	function blStavIzbrisi(blStav) {
        return $.dsDirectCall({ 
            method: "BlStavIzbrisi",
            params:[blStav] 
        });
    }
    
    function blStavMozeIzmijeni(blStav) {
        return $.dsDirectCall({ 
            method: "BlStavMozeIzmijeni",
            params:[blStav] 
        });
    }
    function GetDatumByGodinaVblaRedni(godina,vbla,redni){
		 return $.dsDirectCall({ 
            method: "GetDatumByGodinaVblaRedni",
            params: [ godina,vbla,redni ]
        });
    }  
    
    function SpPutniKnjizPrijedlogOpaska(obj, grid){
		 return $.dsDirectCall({ 
            method: "SpPutniKnjizPrijedlogOpaska",
            params: [ obj, grid ]
        });
    } 
	function ProvjeriIznoseSP(forma){
		return $.dsDirectCallPost({
			method: "ProvjeriIznoseSP",
			controller: "spputniknjiz",
			params: [ ],
			data: [ forma ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
			    KUtils.busy(false);
				if (true){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
		});	
    } 
    
    function DajNalovGridaAk(obj){
		 return $.dsDirectCall({ 
            method: "DajNalovGridaAk",
            params: [ obj ]
        });
    } 
    
    function SetSpStatusIsplaceno(godina,datum1,datum2,datumIzvrsenja,vbla){
		 return $.dsDirectCall({ 
            method: "SetSpStatusIsplaceno",
            params: [ godina, datum1, datum2, datumIzvrsenja, vbla ]
        });
    } 
    
    function ProvjeriDaLiPostojiZbrojni(godina,vbla, redni,valuta){
    	 return $.dsDirectCall({ 
            method: "ProvjeriDaLiPostojiZbrojni",
            params: [ godina, vbla, redni,valuta ]
        });   
    }
    
    function PripremaDisketeZaZN(blizvj, mozeNovi){
    	 return $.dsDirectCall({ 
            method: "PripremaDisketeZaZN",
            params: [ blizvj, mozeNovi ]
        });   
    }
    
    function DajBlDokum(godina, vbla){
    	 return $.dsDirectCall({ 
            method: "DajBlDokum",
            params: [ godina, vbla ]
        });   
    }
   
   function DajBlBrojDokum(godina, dokum){
    	 return $.dsDirectCall({ 
            method: "DajBlBrojDokum",
            params: [ godina, dokum ]
        });   
    } 
    
    function ProvjeriDokPostojiUGk(godina, dokum, brojDok){
    	 return $.dsDirectCall({ 
            method: "ProvjeriDokPostojiUGk",
            params: [ godina, dokum, brojDok ]
        });   
    }
    
    function ArhivaGodinaValidate(godina){
		 return $.dsDirectCall({ 
            method: "ArhivaGodinaValidate",
            params: [ godina ]
        });
    }
    
    function DajOtvoreneStavke(partner, zatvorirn, vbla, konto, ui, datum){
		 return $.dsDirectCall({ 
            method: "DajOtvoreneStavke",
            params: [ partner, zatvorirn, vbla, konto, ui, datum ]
        });
    } 
    
    function DajOsobaBlByZOsoba(osoba){
		 return $.dsDirectCall({ 
            method: "DajOsobaBlByZOsoba",
            params: [ osoba ]
        });
    } 
    
	function DajOsobaBlBySpDJelatnik(spdjelatnik){
		 return $.dsDirectCall({ 
            method: "DajOsobaBlBySpDJelatnik",
            params: [ spdjelatnik ]
        });
    }
        
    function SetObjectAfterOsoba(osoba, vbla, zaglav, datum){
		 return $.dsDirectCall({ 
            method: "SetObjectAfterOsoba",
            params: [ osoba, vbla, zaglav, datum ]
        });
    }     
    
    function SetObjectAfterSvrha(svrha, godina){
		 return $.dsDirectCall({ 
            method: "SetObjectAfterSvrha",
            params: [ svrha, godina ]
        });
    }  
    
    function ProvjeriDaliRnPostojiUSKPoDatumu(datumod, datumdo, vbla) {
    	 return $.dsDirectCall({ 
            method: "ProvjeriDaliRnPostojiUSKPoDatumu",
            params: [ datumod, datumdo, vbla ]
        });
    }  

    function ProvjeriDaliRnPostojiUSKPoPartneru(valuta, zatvorirn, partner, vbla) {
    	 return $.dsDirectCall({ 
            method: "ProvjeriDaliRnPostojiUSKPoPartneru",
            params: [ valuta, zatvorirn, partner, vbla ]
        });
    }  
          
    function KojaUI(uplata, pocSt, tekuci, obracun, izvodBanke) {
    	 return $.dsDirectCall({ 
            method: "KojaUI",
            params: [ uplata, pocSt, tekuci, obracun, izvodBanke ]
        });
    }
    
    function GetZadnjiBlIzvj(vbla, valuta) {
    	 return $.dsDirectCall({ 
            method: "GetZadnjiBlIzvj",
            params: [ vbla, valuta ]
        });
    }
        
    function GetTecajNaDan(valuta, datum) {
    	 return $.dsDirectCall({ 
            method: "GetTecajNaDan",
            params: [ valuta, datum ]
        });
    }
    
    function SpPutniPregDajFormaCaption(putni){
    	 return $.dsDirectCall({ 
            method: "SpPutniPregDajFormaCaption",
            params: [ putni ]
        });
    }
    
    function GetBankaByRacun(racun){
    	 return $.dsDirectCall({ 
            method: "GetBankaByRacun",
            params: [ racun ]
        });
    }
     
      
}(konto.bl.api = {}));